import { supabase } from './client';
import { authService } from './authService';
import { createLogger } from '../logger';

const seatingLog = createLogger('seating');

export const seatingService = {
  async saveSeatingArrangement(inviteCode: string, seatingData: any): Promise<void> {
    const currentUser = await authService.getCurrentUser();
    if (!currentUser) throw new Error('必須登入才能保存座位安排');

    const { error } = await supabase.rpc('save_seating_arrangement', {
      p_invite_code: inviteCode,
      p_seating_data: seatingData
    });

    if (error) throw new Error(`保存座位安排失敗: ${error.message}`);
  },

  async loadSeatingArrangement(inviteCode: string): Promise<any | null> {
    seatingLog.debug('載入座位安排:', inviteCode);

    const { data, error } = await supabase.rpc('get_seating_arrangement', {
      p_invite_code: inviteCode
    });

    if (error) {
      seatingLog.error('載入座位安排錯誤:', error);

      if (error.code === 'PGRST116' || error.message.includes('function') || error.message.includes('does not exist')) {
        seatingLog.debug('座位資料不存在，返回空值');
        return null;
      }

      seatingLog.error('座位安排載入失敗:', error.message);
      throw new Error(`載入座位安排失敗: ${error.message}`);
    }

    seatingLog.info('成功載入座位安排:', data ? '有資料' : '無資料');
    return data || null;
  },

  async deleteSeatingArrangement(inviteCode: string): Promise<void> {
    const { error } = await supabase
      .from('seating_arrangements')
      .delete()
      .eq('invite_code', inviteCode);

    if (error) throw new Error(`刪除座位安排失敗: ${error.message}`);
  },

  async removeGuestFromSeating(inviteCode: string, rsvpId: string): Promise<void> {
    const currentSeating = await this.loadSeatingArrangement(inviteCode);
    if (!currentSeating) return;

    let tables: any[] = Array.isArray(currentSeating) ? currentSeating : currentSeating.tables || [];
    let hasChanges = false;

    tables.forEach((table: any) => {
      if (table.guests && Array.isArray(table.guests)) {
        const originalLength = table.guests.length;
        table.guests = table.guests.filter((guest: any) => {
          const guestId = typeof guest === 'string' ? guest : guest.id;
          return guestId !== rsvpId;
        });
        if (table.guests.length !== originalLength) {
          hasChanges = true;
        }
      }
    });

    if (hasChanges) {
      await this.saveSeatingArrangement(inviteCode, tables);
      seatingLog.info('已從座位安排中清理 RSVP ID:', rsvpId);
    }
  }
};
